import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';

@customElement('info-accordion-element')
export class InfoAccordionElement extends JobindsatsElement(LitElement) {
    static styles = css`
        .accordion-button {
            background-color: #0000;
            text-align: left;
            border: none;
            padding: 0px;
            word-break: break-word;
        }
        @media only screen and (max-width: 1200px) {
            .accordion-button {
                margin: 10px 0px;
            }
        }
        .accordion-heading {
            padding: 20px 30px;
            word-break: break-word;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid var(--divider-color-closed);
            color: var(--main-blue);
        }
         .accordion-heading[aria-expanded="true"] {
              border-top: 0;
        }
        .accordion-heading button {
            color: var(--main-blue);
        }
        @media only screen and (max-width: 550px) {
            .accordion-heading {
                flex-direction: column;
                align-items: flex-start;
                padding-bottom: 30px;
            }
            .maaling-link {
                padding-top: 20px;
            }
        }
        .accordion-content {
            border-bottom: 0;
        }
        .maaling-link {
            flex-shrink: 0;
        }
        `;

    static instance = 0;

    @property()
    title = '';

    @property({
        attribute: 'maaling-url'
    })
    maalingUrl = '';
    
    @property({
        attribute: 'id',
    })
    id = ++InfoAccordionElement.instance + 'lit-accordion';

    @state()
    expanded = false;

    render() {
        return html`
            <div class="accordion-heading" aria-expanded="${this.expanded}">
                    <div role="heading" aria-level=2>
                        <a href="${this.maalingUrl}">
                            ${this.title}
                        </a>
                    </div>
                <div class="maaling-link">
                    <a href="${this.maalingUrl}"><span class="icon border-icon glyphicon glyphicon-chevron-right"></span>Gå til info</a>
                </div>
            </div>
        `;
    }

    toggleAccordion() {
        this.expanded = !this.expanded;
    }
}